import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/prazo-audiometria`;
export const createPrazoAudiometria = async (alimento) => {
  return await axios.post(`${httpUrl}/create`, alimento).then((response) => response);
};

export const getListaPrazosAudiometria = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getPrazoAudiometriaById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deletePrazoAudiometriaById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
